/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: program.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CloneProgramRequest,
  CloneProgramResponse,
  CreateProgramRequest,
  CreateProgramResponse,
  DownloadProgramCaseRecordsRequest,
  DownloadProgramCaseRecordsResponse,
  GetCurrentUserProgramsRequest,
  GetCurrentUserProgramsResponse,
  GetProgramRequest,
  GetProgramResponse,
  GetProgramsRequest,
  GetProgramsResponse,
  UpdateProgramRequest,
  UpdateProgramResponse,
} from '../types/program';

export const createProgramService = (transport: Transport) => ({
  async getProgram(
    request: GetProgramRequest,
    options: RequestOptions = {},
  ): Promise<GetProgramResponse> {
    const { organization_id, program_id } = request;
    const url = getApiPath(API_METHODS.ProgramService.GetProgram, { organization_id, program_id });
    return transport.get<GetProgramResponse>(url, options);
  },

  async getPrograms(
    request: GetProgramsRequest,
    options: RequestOptions = {},
  ): Promise<GetProgramsResponse> {
    const { organization_id } = request;
    const url = getApiPath(API_METHODS.ProgramService.GetPrograms, { organization_id });
    return transport.get<GetProgramsResponse>(url, options);
  },

  async getCurrentUserPrograms(
    request: GetCurrentUserProgramsRequest,
    options: RequestOptions = {},
  ): Promise<GetCurrentUserProgramsResponse> {
    const { organization_id } = request;
    const url = getApiPath(API_METHODS.ProgramService.GetCurrentUserPrograms, { organization_id });
    return transport.get<GetCurrentUserProgramsResponse>(url, options);
  },

  async downloadProgramCaseRecords(
    request: DownloadProgramCaseRecordsRequest,
    options: RequestOptions = {},
  ): Promise<DownloadProgramCaseRecordsResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.ProgramService.DownloadProgramCaseRecords, {
      organization_id,
      program_id,
    });
    return transport.get<DownloadProgramCaseRecordsResponse>(url, { params, ...options });
  },

  async updateProgram(
    request: UpdateProgramRequest,
    options: RequestOptions = {},
  ): Promise<UpdateProgramResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramService.UpdateProgram, {
      organization_id,
      program_id,
    });
    return transport.post<UpdateProgramResponse>(url, body, options);
  },

  async createProgram(
    request: CreateProgramRequest,
    options: RequestOptions = {},
  ): Promise<CreateProgramResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramService.CreateProgram, { organization_id });
    return transport.post<CreateProgramResponse>(url, body, options);
  },

  async cloneProgram(
    request: CloneProgramRequest,
    options: RequestOptions = {},
  ): Promise<CloneProgramResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.ProgramService.CloneProgram, {
      organization_id,
      program_id,
    });
    return transport.post<CloneProgramResponse>(url, body, options);
  },
});

export type ProgramService = ReturnType<typeof createProgramService>;
